import { Fragment } from "react";

function ClassicHowItWork({ title = "How It Works", steps = [] }) {
  return (
    <section className="classic-hiw-grid">
      <h2>{title}</h2>
      <div className="classic-hiw-steps">
        {steps.map((step, index) => (
          <div className="classic-hiw-step" key={index}>
            <img src={step.icon} alt={step.alt || step.title} />
            <div className="classic-hiw-step-cnt">
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ClassicHowItWork;
